<template>
    <div v-if="user.check()" class="cursor-pointer" @click="toggle">
        <svg-icon v-if="!favorite" icon="bookmark" class="w-4 h-4 text-gray-500 hover:text-red-500"></svg-icon>
        <svg-icon v-else icon="bookmark-check-fill" class="w-4 h-4 text-red-500"></svg-icon>
    </div>
</template>
<script>
import Client from "../../js/modules/Client";
import {notify} from "@kyvg/vue3-notification";
import User from "../../js/modules/User";

export default {
    props: [
        'type',
        'id',
        'value',
    ],
    data() {
        return {
            favorite: this.value || false,
            loading: false,
            user: new User(),
        };
    },
    methods: {
        toggle() {
            if(this.loading){
                return;
            }
            this.loading = true;
            Client.post(this.getUrl())
                .then(response => {
                    this.favorite = response.data.favorite;
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    notify({
                        type: 'error',
                        text: 'Не удалось',
                    });
                });
        },
        getUrl() {
            return '/api/v1.1/' + (this.type === 'post' ? 'posts' : 'comments') + '/' + this.id + '/favorite';
        }
    },
}
</script>